import { render, staticRenderFns } from "./PlatformRecharge.vue?vue&type=template&id=10f378b4&scoped=true&"
import script from "./PlatformRecharge.vue?vue&type=script&lang=js&"
export * from "./PlatformRecharge.vue?vue&type=script&lang=js&"
import style0 from "./PlatformRecharge.vue?vue&type=style&index=0&id=10f378b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f378b4",
  null
  
)

export default component.exports